// extracted by mini-css-extract-plugin
module.exports = {"rightAlign":"TileHeader_rightAlign__1UBpD","titleContainer":"TileHeader_titleContainer__1LgCT","icon":"TileHeader_icon__1CF75"};